import axios from 'axios';
import aplicacionesApi from './aplicaciones';
import { getWithToken, postWithToken } from './http-client';
import { safeLocalStorage, safeSessionStorage } from 'legacyfrontend/helpers/ssr-helper';
/* eslint-disable */
export default {
  async getToken() {
    const { hostname } = window.location;
    return aplicacionesApi
      .obtenerAplicacion(hostname)
      .then((res) => res.access_token)
      .catch((res) => {
        safeSessionStorage.setItem(`[TOKEN][${new Date()}]`, JSON.stringify(res));
        return '';
      });
  },
  async obtenerPaquetes(datosBusqueda, token, funcOk, funcErr) {
    /* eslint-disable */
    const dateRequest = new Date();
    let config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: datosBusqueda,
    };

    let totalPaginas = 1;
    let res = null;
    while (datosBusqueda.Pagina <= totalPaginas) {
      try {
        res = await axios
          .get(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetesRegional/`, config)
          .then((res) => res)
          .catch(async (res) => {
            if (parseInt(res.response.status, 10) === 401) {
              const appToken = await this.getToken();
              config.headers.Authorization = `Bearer ${appToken}`;
              return await axios.get(
                `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetesRegional/`,
                config
              );
            }
          });

        datosBusqueda.Pagina++;
        totalPaginas = res.data.paginado.totalPaginas;
        funcOk(res);
      } catch (err) {
        console.error(`Error al obtener los paquetes: ${err?.response?.data}`);
        safeSessionStorage.setItem(`[LOG][${dateRequest}]`, JSON.stringify(res));
        throw new Error(`${err?.response?.data?.message}`);
        funcErr();
        totalPaginas = 0;
      }
    }
    /* eslint-enable */
  },
  async obtenerAgencia(
    {
      paisId,
      provinciaId,
      localidadId,
      appId,
      tipoAccion, // consulta
    },
    token
  ) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios
        .get(
          `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/agencia/derivacion?paisId=${paisId}&provinciaId=${provinciaId}&localidadId=${localidadId}&aplicacionId=${appId}&tipoAccion=${tipoAccion}`,
          config
        );
      return response;
    } catch (error) {
      console.error(`Error al obtener la agencia: ${error?.response?.data}`);
      throw new Error(`${error?.response?.data?.message}`);
    }
  },
  async obtenerDestinos() {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };

    const response = await axios.get(`${process.env.RAZZLE_API_GEO}/destinos/`, config);
    return response.data;
  },
  async obtenerOrigenes() {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };

    const response = await axios.get(`${process.env.RAZZLE_API_GEO}/origenes/`, config);
    return response.data;
  },
  async obtenerDetalle(datos) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: '',
      },
      params: datos,
    };

    const token = await this.getToken();
    config.headers.Authorization = `Bearer ${token}`;

    // safeSessionStorage.setItem("[PAQUETES]["+dateRequest+"]", config);

    try {
      return await axios
        .get(
          `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetesRegional/obtener-detalle-cache`,
          config
        )
        .then((res) => res)
        .catch(async () => {
          // safeSessionStorage.setItem("[CATCH][DETALLE]["+dateRequest+"]", JSON.stringify(res));
          const token2 = await this.getToken();
          config.headers.Authorization = `Bearer ${token2}`;
          return axios.get(
            `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetesRegional/obtener-detalle-cache/`,
            config
          );
        });
    } catch (e) {
      safeSessionStorage.setItem(`[SUPER-CATCH][DETALLE][${new Date()}]`, e);
      return undefined;
    }
  },
  async obtenerDetalleLegacy(datos) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: '',
      },
      params: datos,
    };
    const token = await this.getToken();
    config.headers.Authorization = `Bearer ${token}`;

    try {
      return await axios
        .get(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetesRegional/obtener-detalle`, config)
        .then((res) => res)
        .catch(async () => {
          // safeSessionStorage.setItem("[CATCH][DETALLE]["+dateRequest+"]", JSON.stringify(res));
          const token2 = await this.getToken();
          config.headers.Authorization = `Bearer ${token2}`;
          return axios
            .get(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetesRegional/obtener-detalle/`, config)
            .then((res) => res.data);
        });
    } catch (e) {
      safeSessionStorage.setItem(`[SUPER-CATCH][DETALLE][${new Date()}]`, e);
      return [];
    }
  },
  async createLog(datosPrereserva, token) {
    try {
      const response = await postWithToken(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/logs`, datosPrereserva, token);
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error al crear el log: ${error?.response?.data}`);
      throw new Error(`${error?.response?.data?.message}`);
    }
  },
  async reservar(datosPrereserva, token) {
    try {
      const response = await postWithToken(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/pagos`, datosPrereserva, token);
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error al reservar: ${error?.response?.data}`);
      throw new Error(`${error?.response?.data?.message}`);
    }
  },
  async obtenerPaquetesOfertas() {
    await aplicacionesApi.obtenerAplicacion('mundigea');
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };
    try {
      const response = await axios
        .get(`${process.env.RAZZLE_API_PAQUETES}/paquetes/obtener-ofertas`, config);
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error al obtener las ofertas: ${error?.response?.data}`);
      throw new Error(`${error?.response?.data?.message}`);
    }
  },
  obtenerReserva: (hashReserva, token) =>
    getWithToken(
      `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/reservas/obtener-reserva/${hashReserva}`,
      token
    )
      .then((response) => response)
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(`Error al obtener la reserva: ${error?.response?.data}`);
        throw new Error(`${error?.response?.data?.message}`);
      }),
  async validarCuposAllSeasons(departureId) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };
    try {
      const response = await axios
        .get(
          `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetes/check/availability/${departureId}`,
          config
        );
      return response.data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error al validar los cupos: ${error?.response?.data}`);
      throw new Error(`${error?.response?.data?.message}`);
    }
  },
  async validarCuposAmichi(datos) {
    if (
      safeLocalStorage.getItem('token') === null ||
      safeLocalStorage.getItem('token') === '' ||
      safeLocalStorage.getItem('token') === undefined
    ) {
      const { hostname } = window.location;
      const res = await aplicacionesApi.obtenerAplicacion(hostname);
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${res.access_token}`,
        },
        params: datos,
      };
      try {
        const response = await axios
          .get(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetes/check/amichi-availability`, config);
        return response;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error al validar los cupos: ${error?.response?.data}`);
        throw new Error(`${error?.response?.data?.message}`);
      }
    }
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
      params: datos,
    };

    try {
      const response_1 = await axios
        .get(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetes/check/amichi-availability`, config_1);
      return response_1;
    } catch (error_1) {
      // eslint-disable-next-line no-console
      console.error(`Error al validar los cupos: ${error_1?.response?.data}`);
      throw new Error(`${error_1?.response?.data?.message}`);
    }
  },
  async obtenerPaquetesCategorias(datosBusqueda, token, funcOk, funcErr) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: datosBusqueda,
    };
    let totalPaginas = 1;
    let res = null;
    while (datosBusqueda.Pagina <= totalPaginas) {
      try {
        res = await axios
          .get(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetes/obtener-paquetes-categoria`, config)
          .then((res) => res)

          .catch(async (res) => {
            if (parseInt(res.response.status, 10) === 401) {
              const appToken = await this.getToken();
              config.headers.Authorization = `Bearer ${appToken}`;

              return await axios.get(
                `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/paquetes/obtener-paquetes-categoria?distribucion=`,
                config
              );
            }
          });

        datosBusqueda.Pagina++;

        totalPaginas = res.data.paginado.totalPaginas;
        funcOk(res);
      } catch (err) {
        funcErr();
        totalPaginas = 0;
      }
    }
  },
  async getOrigins(token) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/origins`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las ciudades de origen: ${e?.response?.data}`);
      throw new Error(e?.response?.data?.message);
    }
  },
  async getDestinations(originId, token) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/destinations?originId=${originId}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las ciudades de destino: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getAirports(filters = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: filters,
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/airport`, config);
      return res.data;
    } catch (e) {
      throw new Error(e?.response?.data?.message);
    }
  },
  async getAirportById(id, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/airport/${id}`);
      return res.data;
    } catch (e) {
      throw new Error(`Error fetching airport, id: ${id}: ${e?.response?.data?.message}`);
    }
  },
  async fetchLlegoData(filters = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.post(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego`,
        filters,
        config
      );
      return res.data;
    } catch (error) {
      if (error.name !== 'AbortError' && error.code !== 'ERR_CANCELED') {
        const errorDetails = error?.response?.data || error?.message || 'Error desconocido';
        console.error('Error al obtener los datos de llegada:', errorDetails);
      }

      throw error;
    }
  },
  async getLlegoFlightDetails(params = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params,
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego`, config);
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al obtener los detalles del vuelo: ${errorMessage}`);
      throw new Error(`No pudimos obtener los detalles del vuelo: ${errorMessage}`);
    }
  },
  async getLlegoPricing(params = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params,
    };

    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego/pricing`,
        config
      );
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al obtener las tarifas del vuelo: ${errorMessage}`);
      throw new Error(`No pudimos obtener las tarifas del vuelo: ${errorMessage}`);
    }
  },
  async getLlegoStandalone(params = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params,
    };

    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego/stand-alone-catalogue`,
        config
      );
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al obtener el catálogo de vuelos: ${errorMessage}`);
      throw new Error(`No pudimos obtener el catálogo de vuelos: ${errorMessage}`);
    }
  },
  async createBooking(data = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.post(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego/booking`,
        data,
        config
      );
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al crear la reserva de vuelo: ${errorMessage}`);
      throw new Error(`No pudimos crear la reserva de vuelo: ${errorMessage}`);
    }
  },
  async sendMail(data = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.post(
        `${process.env.RAZZLE_API_MARCA_BLANCA}/booking-notification/send-mail`,
        data,
        config
      );
      return res.data;
    } catch (error) {
      console.error(`Error al enviar el mail: ${error?.response?.data}`);
      throw new Error(`No pudimos enviar el mail: ${error?.response?.data?.message}`);
    }
  },
  async getPackages(query) {
    const config = {
      headers: {
        'Content-type': 'application/json',
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/hotel-information${query}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener los paquetes: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getAvailableDates(query) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/closest-package?originId=${query.originId}&destinationId=${query.destinationId}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las fechas disponibles: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getPackagesV2(query) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package${query}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener los paquetes: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getPackageDetail(packageId) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/${packageId}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener el detalle del paquete: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getInternalPackage(packageId, token, salidaId = null) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      let url = `${process.env.RAZZLE_API_PACKAGE_REGIONAL}/paquetes/salida?id=${packageId}`;
      if (salidaId) {
        url += `&salidaId=${salidaId}`;
      }

      const res = await axios.get(url, config);
      return res.data;
    } catch (e) {
      console.error(`Error al obtener el paquete: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getInternalPackageSalidas (paqueteId, monthYear, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: {
        paqueteId,
        monthYear,
      },
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_REGIONAL}/paquetes/dates`, config);
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las salidas: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  }
};
